import React from 'react';
import styled from 'styled-components';
import Image from 'gatsby-theme-core/src/components/image';
import Button from 'gatsby-theme-core/src/components/button/index';
import Column from '../../column';

const LabelsGrid = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  flex-wrap: wrap;
`;

const sizes = { // @TODO
  small: 40,
  normal: 60,
  large: 80,
};

const Labels = ({
  className,
  columnWidth,
  align,
  justify,
  order,
  labels,
  size,
  offset,
}) => (
  <Column
    className={className}
    columnWidth={columnWidth}
    align={align}
    justify={justify}
    order={order}
    offset={offset}
  >
    <LabelsGrid>
      {labels.map(({ id, image, link }) => (
        <Button
          to={link}
          key={id}
          wrapper
          possibleSpan
          forceLinkOpenInNewTab
        >
          <Image image={image} width={size ? sizes[size] : sizes.normal} />
        </Button>
      ))}
    </LabelsGrid>
  </Column>
);

export default Labels;
